export const START_SOCKET = "START_SOCKET";
export const SOCKET_INITALIZED = "SOCKET_INITALIZED";
export const WRITE_MESSAGE = "WRITE_MESSAGE";
export const START_CONVERSATION = "START_CONVERSATION";
export const DISCONNECT_SOCKET = "DISCONNECT_SOCKET";
